/** Copyright © 2013-2023 DataYes, All Rights Reserved. */

/**
 * 获取 window._config 中的值, 统一使用此函数处理
 */
// eslint-disable-next-line no-underscore-dangle
export const getConfig = (key: string) => window._config[key];

/**
 * Object.keys的typescript版本
 * @param obj
 */
export function keys<T extends Record<string, unknown>>(obj: T) {
  return Object.keys(obj) as (keyof T)[];
}

/**
 * 移动数据的某个元素到新的位置，返回新数组
 * @param array 数组
 * @param from 从哪里
 * @param to 到哪里
 */
export function move<T>(array: T[], from: number, to: number) {
  const newArray = [...array];
  const startIndex = from < 0 ? newArray.length + from : from;
  const endIndex = to < 0 ? newArray.length + to : to;

  if (startIndex >= 0 && startIndex < newArray.length) {
    newArray.splice(endIndex, 0, newArray.splice(from, 1)[0]);
  }
  return newArray;
}

/**
 * 判断输入值是否是null或undefined
 * @param predict
 */
export function isNil(val: unknown): val is null | undefined {
  return val === undefined || val === null;
}
